import { useEffect } from 'react';
import constants from '../constants';

const { BODY_DRAGGABLE_CLASS, SLIDER_HANDLE_SELECTOR } = constants;

function handleMouseDown() {
  document.body.classList.add(BODY_DRAGGABLE_CLASS);
}

function handleMouseUp() {
  document.body.classList.remove(BODY_DRAGGABLE_CLASS);
}

function useGrabbingCursor() {
  useEffect(() => {
    const handle = document.querySelector(SLIDER_HANDLE_SELECTOR);
    // @ts-ignore TS(2531): Object is possibly 'null'.
    handle.addEventListener('mousedown', handleMouseDown);
    // @ts-ignore TS(2531): Object is possibly 'null'.
    handle.addEventListener('touchstart', handleMouseDown);
    document.body.addEventListener('touchend', handleMouseDown);
    document.body.addEventListener('mouseup', handleMouseUp);

    return () => {
      // @ts-ignore TS(2531): Object is possibly 'null'.
      handle.removeEventListener('mousedown', handleMouseDown);
      // @ts-ignore TS(2531): Object is possibly 'null'.
      handle.removeEventListener('touchstart', handleMouseDown);
      document.body.removeEventListener('mouseup', handleMouseUp);
      document.body.removeEventListener('touchend', handleMouseUp);
    };
  }, []);
}

export default useGrabbingCursor;
